/**
 * File cj-event.js.
 * Add cookie when CJEVENT QSP is present
 */

/* Create a new cookie for CJ's tracking solution
 * token name: cje
 * max-age: 13 months
 * domain: top level
 * path: root
 * secure: true
 * httpOnly: false
*/

// If CJEVENT QSP exists, set CJEVENT and cje cookies
if (globalSearchParams) {
  // CJEVENT cookie
  if (globalSearchParams.has("CJEVENT")) {
    const cjValue = globalSearchParams.get("CJEVENT");
    var cjeventExpirationDate = new Date;
    cjeventExpirationDate.setDate(cjeventExpirationDate.getDate() + 14);
    document.cookie = "CJEVENT=" + cjValue + ";domain=" + globalCookieDomain + ";path=/;expires=" + cjeventExpirationDate.toUTCString() + ";";
  }

  // cje cookie
  if (globalLowerSearchParams.has("cjevent")) {
    const cjValue = globalLowerSearchParams.get("cjevent");
    var cjeExpirationDate = new Date;
    cjeExpirationDate.setDate(cjeExpirationDate.getDate() + 395);
    document.cookie = "cje=" + cjValue + ";domain=" + globalCookieDomain + ";path=/;expires=" + cjeExpirationDate.toUTCString() + ";";
  }
}
